import 'reflect-metadata'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import i18n from './i18n'
import { initializeVueEnv } from './infrastructure/vue-env'
import { ClientRouting } from './infrastructure/client-routing'
import { registerAllServices } from './infrastructure/register-services'
import { ClientStorage } from './infrastructure/client-storage'
import { getCurrentUserWrapper } from './infrastructure/current-user-wrapper'

const app = createApp(App);
app.use(router).use(i18n);

router.isReady().then(async () => {
	console.log('Ready...');
	// Initialize VueEnv with routing
	const routing = new ClientRouting(router, router.currentRoute);
	initializeVueEnv(getCurrentUserWrapper(), routing, new ClientStorage());
	
	// Register all services
	registerAllServices();

	app.mount('#app');
});
